import React from 'react'
import useInspectorAlerts from '../../../hooks/useInspectorAlerts'
import ReleaseNotesAutoLauncher from '../../release/ReleaseNotesAutoLauncher'
import InspectorAlertStack from './InspectorAlertStack'

interface FranchiseDataLike {
  has_complete_lightspeed_connection?: boolean
  has_complete_xero_connection?: boolean
}

interface InspectorAlertsMountProps {
  fpCode: string
  franchiseData: FranchiseDataLike | null | undefined
  isSyncing: boolean
  onSyncStarted: () => void
}

const InspectorAlertsMount: React.FC<InspectorAlertsMountProps> = ({
  fpCode,
  franchiseData,
  isSyncing,
  onSyncStarted,
}) => {
  const { alerts } = useInspectorAlerts(fpCode, franchiseData, {
    isSyncing,
    onSyncStarted,
  })

  return (
    <>
      <InspectorAlertStack alerts={alerts} />
      <ReleaseNotesAutoLauncher />
    </>
  )
}

export default InspectorAlertsMount
